import { render } from "./CollapseItem.vue?vue&type=template&id=a9b91efe&scoped=true"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=a9b91efe&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b91efe"]])

export default __exports__